export default function constant(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-sankey/src/constant.js
// module id = 1116
// module chunks = 0